/** Formats ISO date (2027-05-06) or DD/MM/YYYY to display as DD/MM/YYYY */
export const formatExpirationDate = (value) => {
  if (!value) return null;

  const raw = String(value).trim();
  if (!raw || raw.toLowerCase() === "no_expiration") return null;

  const isoMatch = raw.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (isoMatch) {
    return `${isoMatch[3]}/${isoMatch[2]}/${isoMatch[1]}`;
  }

  return raw;
};
